import { Hidden } from '@material-ui/core';
import React from 'react';
import { getFormattedDate, getHourAndMinutesAmPm } from '../../../../../global/helpers/date-helpers';
import { InstitutionProps } from '../../../models/arc-epi-props';
import { PlanHistoryDto } from './plan-history-models';




interface Props {
	item: PlanHistoryDto,
	settings: InstitutionProps,
}


export function AmendmentHistoryView(props: Props) {

	const { item, settings } = props;
	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.dateOfChangeLabel}</p>
				</Hidden>
				<p>
					{getFormattedDate(item?.date_of_change)}
				</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.timeOfChangeLabel}</p>
				</Hidden>
				<p>
					{getHourAndMinutesAmPm(item?.time_of_change && `01/01/2001 ${item?.time_of_change}`)}
				</p>
			</div>

			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.adoptionDateLabel}</p>
				</Hidden>
				<p>
					{getFormattedDate(item?.adoption_date)}
				</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.amendmentDateLabel}</p>
				</Hidden>
				<p>
					{getFormattedDate(item?.amendment_date)}
				</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.employerBaseContributionLabel}</p>
				</Hidden>
				<p>{item?.employer_base}</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.employerMatchContributionLabel}</p>
				</Hidden>
				<p>{item?.employer_match}</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.minimumScheduledHourLabel}</p>
				</Hidden>
				<p>{item?.minimum_scheduled_hours}</p>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{settings?.allowMultipleContributionLabel}</p>
				</Hidden>
				<p>{item?.allow_multiple_contribution_schedules}</p>
			</div>
		</div>);
}